import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const HotelAccordianCard = (props) => {
    const classess = useStyles();
    const { classes, item } = props;
    const hotelInfo = item.actualData;
    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: 'none' }}>
                <CardContent className={classess.cardContent}>
                    <Box 
                  sx={{  
                    display: 'grid',
                    gridTemplateColumns:{
                    xs:'repeat(2,1fr)',
                    md:'repeat(7,1fr)',
                    },
                    flexDirection: 'row',
                    textAlign:'left',
                    justifyContent:'left',
                    alignItems:'left',
                    gap:'10px',
                    flexbasis:'900px'}}
                    >
                        {/* <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Requested For
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{hotelInfo.participant}</span>
                                </Typography>
                            </Box>
                        </Box>*/}
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    First Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{hotelInfo.firstName}</span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Last Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{hotelInfo.lastName}</span>
                                </Typography>
                            </Box>
                        </Box> 
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Check In
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {Helper.FormatDate(
                                            hotelInfo.checkIn
                                        )}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Check Out
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {Helper.FormatDate(
                                            hotelInfo.checkOut
                                        )}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        {hotelInfo.specialRequest !== '' ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Special Request
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: "break-word" }}>
                                        <span>{hotelInfo.specialRequest}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            ''
                        )}
                        {/* </Box>
                    <Box className={classes.rowContent} sx={{ pt: 1 }}> */}
                        {hotelInfo.modifiedByName !== '' &&
                        hotelInfo.modifiedByName !== null ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified By
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{hotelInfo.modifiedByName}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            ''
                        )}
                        {hotelInfo.modifiedDate!=="0001-01-01T00:00:00" 
                       && hotelInfo.modifiedDate !== null ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified Date
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{Helper.FormatDateTime(hotelInfo.modifiedDate)}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            ''
                        )}
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary"></Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}></Typography>
                            </Box>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
};

export default HotelAccordianCard;
